module.exports = __webpack_public_path__ + "assets/img/ad7907602c34d5040c7ca7060cc5ec9e.png";